import React from 'react';

/**
 * Avatar with multi-level fallback:
 * 1. src prop (tiktok_avatar_url from DB)
 * 2. unavatar.io/tiktok/{username}
 * 3. Initials placeholder (never returns null)
 */
const AvatarImg = ({ src, username, size, style, className }) => {
  const clean = username ? username.replace(/^@/, '') : null;
  const fallback = clean ? `https://unavatar.io/tiktok/${clean}` : null;
  const [imgSrc, setImgSrc] = React.useState(src || fallback);
  const [failed, setFailed] = React.useState(false);

  const handleError = () => {
    if (fallback && imgSrc !== fallback) {
      setImgSrc(fallback);
    } else {
      setFailed(true);
    }
  };

  React.useEffect(() => {
    setImgSrc(src || fallback);
    setFailed(false);
  }, [src, fallback]);

  const sizeStyle = size ? { width: size, height: size } : className ? {} : { width: '100%', height: '100%' };

  if (!imgSrc || failed) {
    const initial = clean ? clean[0].toUpperCase() : '?';
    return (
      <div
        className={className}
        style={{
          ...sizeStyle,
          display: 'flex', alignItems: 'center', justifyContent: 'center',
          backgroundColor: '#2a2a2a', color: 'rgba(255,255,255,0.5)',
          fontSize: size ? Math.max(10, size * 0.4) : 12, fontWeight: 700,
          borderRadius: '50%',
          ...style,
        }}
      >
        {initial}
      </div>
    );
  }

  return (
    <img
      src={imgSrc}
      alt=""
      onError={handleError}
      className={className}
      style={{ ...sizeStyle, objectFit: 'cover', ...style }}
    />
  );
};

export default AvatarImg;
